import { createSelector } from "@reduxjs/toolkit";

export const clientState = (state) => state.client;

export const clientSelectors = createSelector(clientState, (state) => state);
